<template>
  <div class='row'>
    <div :class="{ 'col-lg-6 col-xl-3' : this.user.is_admin }" class='col'>
    <stats-card :sub-title='this.getHours()'
                class='mb-4 mb-xl-0'
                icon='ni ni-chart-pie-35'
                title='Stunden'
                type='gradient-orange'>
    </stats-card>
  </div>

  <div :class="{ ' col-lg-6 col-xl-3' : this.user.is_admin }" class='col'>
  <stats-card :sub-title='this.getProfit()'
              class='mb-4 mb-xl-0'
              icon='ni ni ni-credit-card'
              title='Gewinn'
              type='gradient-red'>
  </stats-card>
  </div>

  <div :class="{ ' col-lg-6 col-xl-3' : this.user.is_admin }" class='col'>
  <stats-card :sub-title='this.getSales()'
              class='mb-4 mb-xl-0'
              icon='ni ni-money-coins'
              title='Umsatz'
              type='gradient-green'>
  </stats-card>
  </div>

  <div class='col-xl-3 col-lg-6' v-if='this.user.is_admin'>
    <stats-card :sub-title='String(this.studios.length)'
                class='mb-4 mb-xl-0'
                icon='ni ni-chart-bar-32'
                title='Studios'
                type='gradient-info'>
    </stats-card>
  </div>
  </div>
</template>

<script>
  import firebase from 'firebase/app';
  import { mapState } from 'vuex';

  require('firebase/firestore');

  export default {
    name: 'CardStats',
    props: {
      admin: Boolean
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    data() {
      return {
        studios: [],
        customers: [],
        projects: [],
        hours: 0
      }
    },
    methods: {
      getStudios() {
        this.studios = [];

        firebase.firestore().collection('studios').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let item = { id: doc.id, name: doc.data().name, is_private: doc.data().is_private };

            this.studios.push(item)
          });
        })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.log('Error getting documents: ', error);
          });
      },
      getCustomers() {
        this.customers = [];

        firebase.firestore().collection('customers').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots

            let item = { id: doc.id, name: doc.data().name, hourly_rate: doc.data().hourly_rate };

            this.customers.push(item)
          });
        })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.log('Error getting documents: ', error);
          });
      },
      getProjects() {
        this.projects = [];

        if (this.$route.query.studioId) {
          firebase.firestore().collection('customers').where('studio_id', '==', this.$route.query.studioId).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {

              firebase.firestore().collection('projects').where('customer', '==', doc.id).where('billed', '==', false).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  let item = {
                    id: doc.id,
                    title: doc.data().title,
                    hourly_rate: doc.data().hourly_rate,
                    hours: doc.data().hours
                  };

                  this.projects.push(item)
                });
              })
                .catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log('Error getting documents: ', error);
                });

              let item = { id: doc.id, name: doc.data().name, hourly_rate: doc.data().hourly_rate };

              this.customers.push(item)
            });
          })
            .catch(function (error) {
              // eslint-disable-next-line no-console
              console.log('Error getting documents: ', error);
            });
        } else if (this.$route.query.customerId) {
          firebase.firestore().collection('projects').where('customer', '==', this.$route.query.customerId).where('billed', '==', false).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let item = {
                id: doc.id,
                title: doc.data().title,
                hourly_rate: doc.data().hourly_rate,
                hours: doc.data().hours
              };

              this.projects.push(item)
            });
          })
            .catch(function (error) {
              // eslint-disable-next-line no-console
              console.log('Error getting documents: ', error);
            });
        } else if (!this.$route.query.studioId || !this.$route.query.customerId) {

          firebase.firestore().collection('studios').where('is_private', '==', false).get().then((querySnapshot) => {
            querySnapshot.forEach((studio) => {
              firebase.firestore().collection('customers').where('studio_id', '==', studio.id).get().then((querySnapshot) => {
                querySnapshot.forEach((customer) => {
                  firebase.firestore().collection('projects').where('billed', '==', false).where('customer', '==', customer.id).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                      let item = {
                        id: doc.id,
                        title: doc.data().title,
                        hourly_rate: doc.data().hourly_rate,
                        hours: doc.data().hours
                      };

                      this.projects.push(item)
                    });
                  }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log('Error getting documents: ', error);
                  });
                });
              });
            });
          });
        }

      },

      getSales() {
        let sales = 0;

        this.projects.forEach(item => {
          if (!item.is_private) {
            sales = Number(sales) + (Number(item.hours) * Number(item.hourly_rate));
          }
        });

        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(sales * (1/3))
      }
      ,
      getProfit() {
        let profit = 0;

        this.projects.forEach(item => {
          if (!item.is_private) {
            profit = Number(profit) + (Number(item.hours) * Number(item.hourly_rate));
          }
        });

        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(profit * (2/3))
      }
      ,
      getHours() {
        let hours = 0;

        this.projects.forEach(item => {
          hours = Number(hours) + Number(item.hours);
        });

        return hours + ' std.'
      }
    }
    ,
    watch: {
      $route() {
        if (this.user.is_admin) {
          this.getStudios();
        }
        this.getCustomers();
        this.getProjects();
      }
    }
    ,
    created() {
      if (this.user.is_admin) {
        this.getStudios();
      }
      this.getCustomers();
      this.getProjects();
    }
  }
</script>
